<template>
  <div class="fav-card__wrapper display-flex flex-col">
    <a
      target="_blank"
      
      v-if="type === 'COUNTRY'"
      @click="handleFavClick($event)"
    >
    <div class="fav-card__match-container pointer">
      <div class="fav-card__detail display-flex">
        <div class="display-flex-center">
          <Icon :category="'country'" :logoUrl="logo" class="icon-search-favcard"></Icon>
        </div>
        <div class="fav-card__team">
          <div class="fav-flag-text">{{ name }}</div>
        </div>
      </div>
      <div class="btn-fav-wrapper__search">
        <SvgIcon v-if="type === 'COUNTRY'" icon="more.arrow.right"></SvgIcon>
        <template v-else>
          <div
            v-if="isLogin"
            class="btn-fav-aspn"
            :class="isFav ? 'selected' : null"
            @click="handleFavClick($event)"
          ></div>
        </template>
      </div>
    </div>
    </a>
    <a
      target="_blank"
      class="fav-card__match-container"
      v-else-if="type === 'sample'"
    >
      <div class="fav-card__detail display-flex">
        <div class="display-flex-center fav-flag">
          <img
            src="../../../../static/images/team_logo_default.png"
            alt="logo"
          />
        </div>
        <div class="fav-card__team">
          <div class="flag" v-if="type === 'sample'">{{ name }}</div>
        </div>
      </div>
      <!-- <div class="fav-star" :class="isFav ? 'selected' : null"></div> -->
      <div class="btn-fav-wrapper__search">
        <div class="btn-fav-aspn" v-if="isLogin"></div>
      </div>
    </a>
    <a v-else-if="isDisableRedirect" class="fav-card__match-container">
      <div class="fav-card__detail display-flex">
        <div class="display-flex-center">
          <img
            v-if="!logo"
            src="../../../../static/images/icons/icon_flag_empty.png"
            alt="logo"
          />
          <Icon v-else :category="'country'" :logoUrl="logo"></Icon>
        </div>
        <div class="fav-card__team">
          <div class="flag">{{ name }}</div>
          <div class="flag" v-if="type === 'sample'">Country</div>
        </div>
      </div>
      <!-- <div class="fav-star" :class="isFav ? 'selected' : null"></div> -->
      <div
        class="btn-fav-wrapper__search"
        @click.prevent="handleFavClick($event)"
      >
        <div class="btn-fav" :class="isFav ? 'selected' : null"></div>
      </div>
    </a>
    <router-link :to="urlPath" @click="handleRedirect($event)" v-else>
      <div class="fav-card__match-container">
        <div class="fav-card__detail display-flex">
          <div class="display-flex-center">
            <leagueIcon v-if="type === 'COMPETITIONS'" :icon="keyName" className="icon-search-favcard">
              <img
                v-if="!logo"
                src="../../../../static/images/icons/icon_flag_empty.png"
                alt="logo"
              />
              <Icon v-else :category="'country'" :logoUrl="logo" class="icon-search-favcard"></Icon>
            </leagueIcon>
            <template v-else>
              <img
                v-if="!logo"
                src="../../../../static/images/icons/icon_flag_empty.png"
                alt="logo"
              />
              <Icon v-else :category="'country'" :logoUrl="logo" class="icon-search-favcard"></Icon>
            </template>
          </div>
          <div class="fav-card__team">
            <div class="fav-card__subtitle" v-if="subtitle">{{subtitle}}</div>
            <div class="fav-flag-text">{{ name }}</div>
            <!-- <div class="flag" v-if="type === 'sample'">Country</div> -->
          </div>
        </div>
        <!-- <div class="fav-star" :class="isFav ? 'selected' : null"></div> -->
        <div
          class="btn-fav-wrapper__search"
          @click.stop.prevent="handleFavClick($event)"
        >
        <template v-if="isLogin">

          <div class="btn-fav-aspn-mobile search-card-btn-fav" 
            :class="isFav ? 'selected' : null"
            v-if="isMobile"></div>
          <div class="btn-fav-aspn search-card-btn-fav" 
            :class="isFav ? 'selected' : null"
            v-if="!isMobile"></div>
        </template>
        </div>
      </div>
    </router-link>
  </div>
  <PopUpSignInIndexMobile
    ref="PopUpSignInIndexMobileRef"
    :pathName="`/${currentLocale}/signin`"
    :message="$i18n.t('FAV_LOGIN_TIPS')"
    :title="$i18n.t('FAV_LOGIN_TITLE')"
    class="login-fav-popup"
  ></PopUpSignInIndexMobile>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import PopUpSignInIndexMobile from "@/components/user/PopUpSignInIndexMobile.vue";
import leagueIcon from '@/components/Icon/LeagueIcon.vue'
export default {
  props: [
    "id",
    "name",
    "logo",
    "isFav",
    "type",
    "titleType",
    "keyName",
    "countryKey",
    "object",
    "isShowCompetionFromCountry",
    "isDisableRedirect",
    "subtitle"
  ],
  data() {
    return {};
  },
  components: {
    PopUpSignInIndexMobile,
    leagueIcon
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "userInfo",
      "currentLocale",
      "currentSportType",
      "isMobile",
    ]),
    urlPath() {
      if (this.isDisableRedirect) {
        return "/#";
      } else {
        if (this.type === "COMPETITIONS" || this.type === "COMPETITION") {
          return {
            path: `/${this.currentLocale}/${this.currentSportType}/${this.countryKey}/${this.keyName}`,
            query: {
              leagueId: this.id,
            },
          };
        } else if(this.type === 'TEAMS' || this.type === 'TEAM')  {
          return {
            path: `/${this.currentLocale}/${
              this.currentSportType
            }/team/${this.name.split(" ").join("-")}/${this.id}`,
          };
        }
        else if(this.type === 'PLAYERS' || this.type === 'PLAYER') {
          return {
            path: `/${this.currentLocale}/${
              this.currentSportType
            }/player/${this.name.split(" ").join("-")}/${this.id}`,
          };
        } else {
          return "/#";
        }
      }
    },
  },
  methods: {
    ...mapActions(["favLoginTipsChangeEvent"]),
    handleFavClick(event) {
      if (this.isLogin) {
        this.$emit(
          "favHandler",
          this.id,
          this.isFav,
          this.titleType,
          this.name,
          this.type,
          this.object
        );
      } else {
        if (this.titleType === "COUNTRY" && !this.isShowCompetionFromCountry) {
          this.$emit(
            "favHandler",
            this.id,
            this.isFav,
            this.titleType,
            this.name,
            this.type,
            this.object
          );
        } else {
          if (this.isMobile) {
            this.$refs.PopUpSignInIndexMobileRef.handleOpen();
          } else {
            this.favLoginTipsChangeEvent({ isOpen: true, event: event });
          }
        }
      }
    },
    handleRedirect(event) {
      if (this.isDisableRedirect) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.$emit("pageIsRedirected");
    },
  },
};
</script>

<style scoped>
.fav-card__wrapper {
  width: 100%;
  gap: 0.5rem;
}
.fav-card__match-container:hover {
  background-color: var(--color-background-default-secondary-hover);
}
.fav-card__match-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* background-color: var(--color-theme); */
  border-radius: 0.5rem;
  width: inherit;
  box-sizing: border-box;
  padding: 0rem 0 0rem 0.625rem;
  border-left: 0.4rem solid transparent;
  height: 3.125rem;
}
.fav-card__detail {
  align-items: center;
  gap: 0.708rem;
  font-size: 0.875rem;
  /* line-height: 1.25rem; */
}
.fav-card__team div:nth-child(2) {
  font-family: var(--weight-700);
}
.fav-card__team div:nth-child(3) {
  font-size: 0.625rem;
  line-height: 1rem;
  color: #93a9b4;
}
.fav-flag {
  width: 1.25rem;
  height: 1.25rem;
  object-fit: contain;
}
.fav-flag img {
  width: 100%;
  height: 100%;
}
.fav-flag-text {
  letter-spacing: .56px;
  font-family: var(--weight-600);
}
.fav-star {
  width: 1.25rem;
  height: 1.25rem;
  background: url("../../../../static/images/icons/icon_star_white.png")
    no-repeat center center;
  background-size: contain;
}
.fav-star.selected {
  background: url("../../../../static/images/icons/icon_star_selected.png")
    no-repeat center center;
}
.live-selected {
  border-left: 0.5rem solid var(--color-icon-primary-active);
}
.btn-arrow-right {
  background: url("../../../../static/images/icon_arrow_right.png") no-repeat
    center center;
  width: 1rem;
  height: 1rem;
  background-size: contain;
}
.search-card-btn-fav {
  width: 22.83px;
  height: 21.8px;
}
.fav-card__subtitle {
  color: var(--color-text-default-secondary);
  font-size: 12px;
	letter-spacing: 0.2px;
}

.icon-search-favcard {
  width: 34px;
  height: 34px;
}


@media(max-width: 768px) { /* for test */
  .fav-flag-text {
    font-size: 14px;
  }
  .fav-card__subtitle {
    font-size: 13px;
    color: var(--color-text-default-secondary);
  }
  .fav-card__match-container {
    background-color: var(--color-background-default-tertiary);
    height: auto;
    padding: 16px;
    border: 0;
    margin: 0 8px;
  }
  .fav-card__match-container:hover {
    /* background-color: var(--color-theme); */
  }
  .btn-fav-wrapper__search {
    width: unset;
  }
  .fav-icon {
    width: 24px;
  }
}
</style>

<style>
.icon-search-favcard {
  width: 34px;
  height: 34px;
}

@media(max-width: 768px)  {
.icon-search-favcard {
  width: 48px !important;
  height: 48px !important;
}
}
</style>